import React, { memo } from 'react'

import { TextInput, Icon, Search, ChevronRight } from '@cgtrader/triangle-ui/dist/src/ssr-index'

import { iconSize } from 'Pods/ThreeDStudio/constants'

import { SEARCH_CATEGORIES } from '../../mockData'
import CategoryGrid from './Components/CategoryGrid/CategoryGrid'
import ImageGrid from './Components/ImageGrid/ImageGrid'
import NoResults from './Components/NoResults/NoResults'
import SearchLoading from './Components/SearchLoading/SearchLoading'
import useSearchTab, { SEARCH_STATE } from './useSearchTab'

const CHEVRON_SIZE = { height: '12px', width: '12px' }
const searchIcon = <Icon svgComponent={Search} size={iconSize} color="dark" notSpaced />

function SearchTab() {
  const {
    query,
    searchState,
    searchResults,
    selectedCategory,
    selectedImage,
    onSelectImage,
    handleQueryChange,
    handleSearchKeyDown,
    handleSelectCategory,
    handleBackToCategories,
    handleApply,
    handleEdit,
    handleCloseExpanded,
    handleCreateImage,
  } = useSearchTab()

  const renderBody = () => {
    if (searchState === SEARCH_STATE.LOADING) {
      return <SearchLoading />
    }

    if (searchState === SEARCH_STATE.EMPTY) {
      return <NoResults onCreate={handleCreateImage} />
    }

    if (searchState === SEARCH_STATE.RESULTS) {
      return (
        <ImageGrid
          images={searchResults}
          selectedImage={selectedImage}
          onSelectImage={onSelectImage}
          onClose={handleCloseExpanded}
          onApply={handleApply}
          onEdit={handleEdit}
        />
      )
    }

    if (selectedCategory) {
      const header = (
        <span className="image-assistant-panel__overline image-assistant-panel__breadcrumb cgt-overline-sm">
          <button type="button" className="image-assistant-panel__breadcrumb-link" onClick={handleBackToCategories}>
            The most searched image categories
          </button>
          <Icon svgComponent={ChevronRight} size={CHEVRON_SIZE} notSpaced />
          {selectedCategory.name}
        </span>
      )

      return (
        <ImageGrid
          images={selectedCategory.images}
          selectedImage={selectedImage}
          header={header}
          onSelectImage={onSelectImage}
          onClose={handleCloseExpanded}
          onApply={handleApply}
          onEdit={handleEdit}
        />
      )
    }

    return <CategoryGrid categories={SEARCH_CATEGORIES} onSelectCategory={handleSelectCategory} />
  }

  return (
    <div className="image-assistant-panel__search">
      <TextInput
        id="image-assistant-search"
        isPilot
        size="small"
        placeholder="Search reference images"
        value={query}
        onChange={handleQueryChange}
        onKeyDown={handleSearchKeyDown}
        leadIcon={searchIcon}
      />
      {renderBody()}
    </div>
  )
}

export default memo(SearchTab)
